/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable max-len */
import Vue from 'vue';
import VueRouter from 'vue-router';
import { helpers } from '@/util/helpers';
import { authGuard, loginGuard, roleGuard, roleAndPermissionGuard } from './guards';
import Login from '../views/Login';
import ForgotPassword from '../views/ForgotPassword.vue';
import ResetPassword from '../views/ResetPassword.vue';
import store from '../store/index';
import axios from 'axios';
import eventBus, { OPEN_SNACKBAR } from '@/util/event-bus';
import i18n from '@/i18n/i18n-config';

Vue.use(VueRouter);

function rootRedirect() {
  if (helpers.$isUser() || helpers.$isPrintTerminal()) {
    return { name: 'permits', query: store.state.permits.permitFilterParams };
  }
  if (helpers.$isImpeccableReputationInstitutionEmployee()) {
    return {
      name: 'impeccableReputationChecks',
      query: store.state.impeccableReputationChecks.impeccableReputationChecksFilterParams,
    };
  }
  return { name: 'home', query: store.state.permitStatistics.permitStatusStatisticsFilterParams };
}

const routes = [
  {
    path: '/',
    redirect: () => rootRedirect(),
    // redirect: () => ({
    //   name:
    //     helpers.$isUser() || helpers.$isPrintTerminal()
    //       ? 'permits'
    //       : helpers.$isImpeccableReputationInstitutionEmployee()
    //       ? 'impeccableReputationChecks'
    //       : 'home',
    //   query:
    //     helpers.$isUser() || helpers.$isPrintTerminal()
    //       ? store.state.permits.permitFilterParams
    //       : helpers.$isImpeccableReputationInstitutionEmployee()
    //       ? store.state.impeccableReputationChecks.impeccableReputationChecksFilterParams
    //       : store.state.permitStatistics.permitStatusStatisticsFilterParams,
    // }),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/Home'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin', 'subject_admin', 'ltou_admin', 'ltou_employee'] },
    children: [
      {
        path: 'edit-permit/:id',
        name: 'home/editPermit',
        component: () => import('@/views/permits/EditPermit'),
        beforeEnter: authGuard,
        meta: {
          getReturnRoute: () => ({
            name: 'home',
            query: store.state.permitStatistics.permitStatusStatisticsFilterParams,
          }),
        },
        children: [
          {
            path: 'confirm-status',
            name: 'confirmHomeEditStatus',
            meta: {
              getReturnRoute: () => ({
                name: 'home',
                query: store.state.permitStatistics.permitStatusStatisticsFilterParams,
              }),
            },
            component: () => import('@/views/permits/PermitEditStatusConfirm'),
            beforeEnter: authGuard,
          },
          {
            path: 'copy-document/:document_id',
            name: 'permitHomeDocument/copy',
            component: () => import('@/views/documents/CopyDocument'),
            beforeEnter: authGuard,
            meta: {
              getReturnRoute: () => ({
                name: 'home',
                query: store.state.permitStatistics.permitStatusStatisticsFilterParams,
              }),
            },
          },

          {
            path: 'view-document/:documentId',
            name: 'home/permitDocument/view',
            component: () => import('@/views/documents/ViewDocument'),
            beforeEnter: authGuard,
            meta: {
              getReturnRoute: () => ({
                name: 'home',
                query: store.state.permitStatistics.permitStatusStatisticsFilterParams,
              }),
            },
          },
        ],
      },
    ],
  },
   {
    path: '/login',
    name: 'login',
    component: Login,
    beforeEnter: loginGuard,
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: ForgotPassword,
    beforeEnter: loginGuard,
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: ResetPassword,
    beforeEnter: loginGuard,
  },
  {
    path: '/profile',
    name: 'profile',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // webpackChunkName says what will the import look like in the network tab.
    component: () => import('../views/Profile'),
    beforeEnter: authGuard,
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('../views/users/Users'),
    beforeEnter: roleAndPermissionGuard,
    meta: { requiredPermission: ['see_subject_admins_who_is_allowed_to_approve_driving_permit'], allowedRoles: ['admin', 'subject_admin', 'ltou_admin', 'ltou_employee'] },
    children: [
      {
        path: 'create',
        name: 'createUser',
        component: () => import('../views/users/CreateUser'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin', 'subject_admin', 'ltou_admin', 'ltou_employee'] },
      },
      {
        path: ':id/edit',
        name: 'editUser',
        component: () => import('../views/users/EditUser'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin', 'subject_admin', 'ltou_admin', 'ltou_employee'] },
      },
      {
        path: 'import-users',
        name: 'importUsers',
        component: () => import('../views/users/ImportUsers'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin', 'subject_admin', 'ltou_admin', 'ltou_employee'] },
      },
      ,
      {
        path: 'send-email-subject-admins',
        name: 'sendEmailSubjectAdmins',
        component: () => import('../views/users/SendEmailSubjectAdmins'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'] },
      },
    ],
  },
  {
    path: '/airports',
    name: 'airports',
    component: () => import('../views/airports/Airports'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin'], menuGroup: 'settings' },
    children: [
      {
        path: ':id/edit',
        name: 'editAirport',
        component: () => import('../views/airports/EditAirport'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin'], menuGroup: 'settings' },
      },
    ],
  },
  {
    path: '/exams',
    name: 'exams',
    component: () => import('../views/exams/Exams'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin', 'ltou_admin'], menuGroup: 'settings' },
    children: [
      {
        path: ':id/edit',
        name: 'editExam',
        component: () => import('../views/exams/EditExam'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin', 'ltou_admin'], menuGroup: 'settings' },
      },
    ],
  },
  {
    path: '/background-checks',
    name: 'backgroundChecks',
    component: () => import('@/views/background-checks/BackgroundChecks'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'] },
    children: [
      // {
      //   path: 'create',
      //   name: 'createBackgroundCheck',
      //   component: () =>
      //     import(
      //        '@/views/background-checks/CreateBackgroundCheck'
      //     ),
      //   beforeEnter: roleGuard,
      //   meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'] },
      // },
      {
        path: ':id/edit',
        name: 'editBackgroundCheck',
        component: () => import('@/views/background-checks/EditBackgroundCheck'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'] },
      },
    ],
  },
  {
    path: '/impeccable-reputation-checks',
    name: 'impeccableReputationChecks',
    component: () => import('@/views/impeccable-reputation-checks/ImpeccableReputationChecks'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin', 'impeccable_reputation_institution_employee'] },
    children: [
      {
        path: ':id/view',
        name: 'viewImpeccableReputationCheck',
        component: () =>
          import('@/views/impeccable-reputation-checks/ViewImpeccableReputationCheck'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin', 'impeccable_reputation_institution_employee'] },
      },
      {
        path: ':id/changes-history',
        name: 'viewImpeccableReputationCheckHistory',
        component: () =>
          import('@/views/impeccable-reputation-checks/ViewImpeccableReputationChecksHistory'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin', 'impeccable_reputation_institution_employee'] },
      },
    ],
  },
  {
    path: '/rejected-permits',
    name: 'rejectedPermits',
    component: () => import('@/views/RejectedPermits.vue'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin', 'impeccable_reputation_institution_employee'] },
  },
  {
    path: '/location-check-in',
    name: 'locationCheckIn',
    component: () => import('@/views/location-check-in/LocationCheckIn'),
    beforeEnter: roleAndPermissionGuard,
    meta: { requiredPermission: ['view_locations'], allowedRoles: ['admin', 'ltou_admin'] },
    children: [
      {
        path: 'locations',
        name: 'locations',
        component: () => import('@/views/location-check-in/Locations'),
        beforeEnter: roleAndPermissionGuard,
        meta: { requiredPermission: ['view_locations'], allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'] },
        children: [
          {
            path: 'create',
            name: 'createLocation',
            component: () => import('@/views/location-check-in/CreateLocation'),
            beforeEnter: roleGuard,
            meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'] },
          },
          {
            path: ':id/edit',
            name: 'editLocation',
            component: () => import('../views/location-check-in/EditLocation'),
            beforeEnter: roleGuard,
            meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'] },
          },
          {
            path: ':id/change-number',
            name: 'editLocationNumber',
            component: () => import('../views/location-check-in/EditLocationNumber'),
            beforeEnter: roleGuard,
            meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'] }
          },
          {
            path: ':id/locations-changes-history',
            name: 'viewLocationChangesHistory',
            component: () => import('@/views/location-check-in/ViewLocationChangesHistory'),
            beforeEnter: authGuard,
            meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'] }
          },
        ],
      },
      {
        path: 'user-codes',
        name: 'userCodes',
        component: () => import('@/views/location-check-in/UserCodes'),
        beforeEnter: roleAndPermissionGuard,
        meta: { requiredPermission: ['view_locations'], allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'] },
        children: [
          {
            path: 'create',
            name: 'createUserCode',
            component: () => import('@/views/location-check-in/CreateUserCode'),
            beforeEnter: roleAndPermissionGuard,
            meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'] },
          },
          {
            path: ':id/edit',
            name: 'editUserCode',
            component: () => import('../views/location-check-in/EditUserCode'),
            beforeEnter: roleAndPermissionGuard,
            meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'] },
          },
        ],
      },
      {
        path: 'location-check-in-history',
        name: 'locationCheckInHistory',
        component: () => import('@/views/location-check-in/LocationCheckInHistory'),
        beforeEnter: roleAndPermissionGuard,
        meta: { requiredPermission: ['view_locations'], allowedRoles: ['admin', 'ltou_admin'] },
      },
    ],
  },
  {
    path: '/countries',
    name: 'countries',
    component: () => import('../views/countries/Countries'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin'], menuGroup: 'settings' },
  },
  {
    path: '/permit-documents',
    name: 'documents',
    component: () => import('@/views/documents/Documents'),
    beforeEnter: authGuard,
    children: [
      {
        path: 'create',
        name: 'createDocument',
        component: () => import('@/views/documents/CreateDocument'),
        beforeEnter: authGuard,
      },
      {
        path: ':id/edit',
        name: 'editDocument',
        component: () => import('../views/documents/EditDocument'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin'] },
      },
      {
        path: ':documentId/view',
        name: 'document/view',
        component: () => import('@/views/documents/ViewDocument'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/living-addresses',
    name: 'livingAddresses',
    component: () => import('@/views/living-addresses/LivingAddresses'),
    beforeEnter: authGuard,
    children: [
      {
        path: 'create',
        name: 'createLivingAddress',
        component: () => import('@/views/living-addresses/CreateLivingAddress'),
        beforeEnter: authGuard,
      },
      {
        path: ':id/edit',
        name: 'editLivingAddress',
        component: () => import('@/views/living-addresses/EditLivingAddress'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/parking-info',
    name: 'approveParkingInfo',
    component: () => import('@/views/approve-parking-info/ApproveParkingInfo'),
    beforeEnter: roleAndPermissionGuard,
    meta: {
      allowedRoles: ['admin', 'ltou_admin'],
      requiredPermission: ['approve_parking_info'],
    },
    children: [
      {
        path: ':id/approve-parking-info',
        name: 'approveParkingPermit',
        component: () => import('@/views/approve-parking-info/ApproveParkingPermit'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin', 'ltou_admin'],
          requiredPermission: ['approve_parking_info'],
        },
        children: [
          {
            path: 'view-document/:documentId',
            name: 'approveParkingDocument/view',
            component: () => import('@/views/documents/ViewDocument'),
            beforeEnter: roleAndPermissionGuard,
            meta: {
              allowedRoles: ['admin', 'ltou_admin'],
              requiredPermission: ['approve_parking_info'],
            },
          },
        ],
      },
    ],
  },
  {
    path: '/permits',
    name: 'permits',
    component: () => import('@/views/permits/Permits'),
    beforeEnter: authGuard,
    children: [
      {
        path: 'create',
        name: 'createPermit',
        component: () => import('@/views/permits/CreatePermit'),
        beforeEnter: authGuard,
        children: [
          {
            path: 'confirm-status',
            name: 'confirmCreateStatus',
            component: () => import('@/views/permits/PermitCreateStatusConfirm'),
            beforeEnter: authGuard,
            meta: {
              getReturnRoute: () => ({
                name: 'permits',
                query: store.state.permits.permitFilterParams,
              }),
            },
          },
        ],
      },
      {
        path: ':id/approve',
        name: 'approvePermit',
        component: () => import('@/views/permits/ApprovePermit'),
        beforeEnter: authGuard,
      },
      {
        path: 'view-permit-as-pdf/:permitId',
        name: 'viewPermitAsPdf',
        component: () => import('@/views/permits/ViewPermitAsPdf'),
        beforeEnter: authGuard,
      },
      {
        path: ':permitId/status-change-history',
        name: 'viewPermitStatusChangeHistory',
        component: () => import('@/views/permits/ViewPermitStatusChangeHistory.vue'),
        beforeEnter: authGuard,
      },
      {
        path: ':id/edit',
        name: 'editPermit',
        component: () => import('@/views/permits/EditPermit'),
        beforeEnter: authGuard,
        meta: {
          getReturnRoute: () => ({
            name: 'permits',
            query: store.state.permits.permitFilterParams,
          }),
        },
        children: [
          {
            path: 'confirm-status',
            name: 'confirmEditStatus',
            component: () => import('@/views/permits/PermitEditStatusConfirm'),
            beforeEnter: authGuard,
            meta: {
              getReturnRoute: () => ({
                name: 'permits',
                query: store.state.permits.permitFilterParams,
              }),
            },
          },
          {
            path: 'view-document/:documentId',
            name: 'permitDocument/view',
            component: () => import('@/views/documents/ViewDocument'),
            beforeEnter: authGuard,
            meta: {
              getReturnRoute: () => ({
                name: 'permits',
                query: store.state.permits.permitFilterParams,
              }),
            },
          },
          {
            path: 'copy-document/:document_id',
            name: 'permitDocument/copy',
            component: () => import('@/views/documents/CopyDocument'),
            beforeEnter: authGuard,
            meta: {
              getReturnRoute: () => ({
                name: 'permits',
                query: store.state.permits.permitFilterParams,
              }),
            },
          },
        ],
      },
      {
        path: 'permit-cards',
        name: 'permitCards',
        component: () => import('@/views/permit-cards/PermitCards'),
        beforeEnter: authGuard,
        children: [
          {
            path: 'create',
            name: 'createPermitCard',
            component: () => import('@/views/permit-cards/CreatePermitCard'),
            beforeEnter: roleGuard,
            meta: { allowedRoles: ['admin', 'subject_admin', 'ltou_admin', 'ltou_employee'] },
          },
        ],
      },
      {
        path: ':permitId/permit-status',
        name: 'viewPermitStatus',
        component: () => import('@/views/permits/ViewPermitStatus'),
        beforeEnter: authGuard,
      },
      {
        path: 'permit-report',
        name: 'permitReport',
        component: () => import('@/views/permit-report/PermitReport'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/training-results',
    name: 'trainingResults',
    component: () => import('@/views/training-results/TrainingResults'),
    beforeEnter: roleAndPermissionGuard,
    meta: {
      allowedRoles: ['admin', 'user', 'subject_admin', 'ltou_admin', 'ltou_employee'],
      requiredPermission: ['driving_training_instructor'],
    },
    children: [
      {
        path: 'create',
        name: 'createTrainingResult',
        component: () => import('@/views/training-results/CreateTrainingResult'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'],
        },
      },
      {
        path: ':id/edit',
        name: 'editTrainingResult',
        component: () => import('@/views/training-results/EditTrainingResult'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'],
        },
      },
    ],
  },

  {
    path: '/permit-prices',
    name: 'permitPrices',
    component: () => import('@/views/permit-prices/PermitPrices'),
    beforeEnter: roleAndPermissionGuard,
    meta: {
      allowedRoles: ['admin', 'ltou_admin'],
      requiredPermission: ['driving_training_instructor'],
      menuGroup: 'settings',
    },
    children: [
      {
        path: 'create',
        name: 'createPermitPrice',
        component: () => import('@/views/permit-prices/CreatePermitPrice'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin', 'ltou_admin'],
          requiredPermission: ['driving_training_instructor'],
          menuGroup: 'settings',
        },
      },
      {
        path: ':id/edit',
        name: 'editPermitPrice',
        component: () => import('@/views/permit-prices/EditPermitPrice'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin', 'ltou_admin'],
          requiredPermission: ['driving_training_instructor'],
          menuGroup: 'settings',
        },
      },
    ],
  },

  {
    path: '/system-settings',
    name: 'systemSettings',
    component: () => import('@/views/settings/SystemSettings'),
    beforeEnter: roleAndPermissionGuard,
    meta: {
      allowedRoles: ['admin', 'ltou_admin'],
      requiredPermission: ['driving_training_instructor'],
      menuGroup: 'settings',
    },
    children: [
      {
        path: 'create',
        name: 'settingsCreateDrivingPermit',
        component: () => import('@/views/settings/CreateDrivingPermit'),
        beforeEnter: authGuard,
      }
    ]
  },
  {
    path: '/subjects',
    name: 'subjects',
    component: () => import('../views/subjects/Subjects'),
    beforeEnter: roleAndPermissionGuard,
    meta: {
      allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'],
      requiredPermission: ['create_subject'],
    },
    children: [
      {
        path: 'create',
        name: 'createSubject',
        component: () => import('../views/subjects/CreateSubject'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'],
          requiredPermission: ['create_subject'],
        },
      },
      {
        path: ':id/edit',
        name: 'editSubject',
        component: () => import('../views/subjects/EditSubject'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'],
          requiredPermission: ['create_subject'],
        },
      },
    ],
  },
  {
    path: '/work-places',
    name: 'workPlaces',
    component: () => import('@/views/work-places/WorkPlaces'),
    beforeEnter: authGuard,
    children: [
      {
        path: 'create',
        name: 'createWorkPlace',
        component: () => import('@/views/work-places/CreateWorkPlace'),
        beforeEnter: authGuard,
      },
      {
        path: ':id/edit',
        name: 'editWorkPlace',
        component: () => import('@/views/work-places/EditWorkPlace'),
        beforeEnter: authGuard,
      },
    ],
  },
  {
    path: '/zones',
    name: 'zones',
    component: () => import('../views/zones/Zones'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin'], menuGroup: 'settings' },
    children: [
      {
        path: 'create',
        name: 'createZone',
        component: () => import('../views/zones/CreateZone'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin'], menuGroup: 'settings' },
      },
      {
        path: ':id/edit',
        name: 'editZone',
        component: () => import('../views/zones/EditZone'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin'], menuGroup: 'settings' },
      },
    ],
  },
  {
    path: '/permit-statistics',
    name: 'permitStatistics',
    component: () => import('../views/PermitStatistics'),
    beforeEnter: roleGuard,
    meta: {
      allowedRoles: ['admin', 'ltou_admin', 'subject_admin', 'ltou_employee'],
      menuGroup: 'statistics',
    },
  },
  {
    path: '/driving-permit-statistics',
    name: 'drivingPermitStatistics',
    component: () => import('../views/DrivingPermitStatistics'),
    beforeEnter: roleAndPermissionGuard,
    meta: {
      allowedRoles: ['admin'],
      requiredPermission: ['driving_training_instructor'],
      menuGroup: 'statistics',
    },
  },
  {
    path: '/login-history',
    name: 'loginHistory',
    component: () => import('../views/LoginHistory'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin'], menuGroup: 'settings' },
  },
  {
    path: '/change-history',
    name: 'changeHistory',
    component: () => import('../views/ChangeHistory'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin', 'ltou_admin'], menuGroup: 'settings' },
  },
  {
    path: '/permit-fields',
    name: 'permitFields',
    component: () => import('@/views/permit-fields/PermitFields'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin'], menuGroup: 'settings' },
    children: [
      {
        path: 'create',
        name: 'createPermitField',
        component: () => import('@/views/permit-fields/CreatePermitField'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin'], menuGroup: 'settings' },
      },
      {
        path: ':id/edit',
        name: 'editPermitField',
        component: () => import('@/views/permit-fields/EditPermitField'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin'], menuGroup: 'settings' },
      },
    ],
  },
  {
    path: '/permits/:hash/check-permit',
    name: 'checkPermit',
    component: () => import('@/views/check-permit/CheckPermit'),
    meta: { isPublic: true },
    children: [
      {
        path: ':permitId/report/:airportId',
        name: 'reportPermitIssue',
        component: () => import('@/views/ReportPermitIssue'),
        meta: { isPublic: true },
      },
    ],
  },
  {
    path: '/email-logs',
    name: 'emailLogs',
    component: () => import('@/views/email-logs/EmailLogs'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'], menuGroup: 'settings' },
    children: [
      {
        path: ':id/view',
        name: 'viewEmailLog',
        component: () => import('@/views/email-logs/ViewEmailLog'),
        beforeEnter: roleGuard,
        meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'], menuGroup: 'settings' },
      },
    ],
  },
  {
    path: '/permit-issues',
    name: 'permitIssues',
    component: () => import('@/views/permit-issues/PermitIssues'),
    beforeEnter: roleAndPermissionGuard,
    meta: {
      allowedRoles: ['admin', 'ltou_admin'],
      requiredPermission: ['is_visible_access_attempts'],
      menuGroup: 'permit-issues',
    },
    children: [
      {
        path: 'edit-permit/:id',
        name: 'permitIssues/editPermit',
        component: () => import('@/views/permits/EditPermit'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin', 'ltou_admin'],
          requiredPermission: ['is_visible_access_attempts'],
          menuGroup: 'permit-issues',
          noSave: true,
          getReturnRoute: () => ({
            name: 'permitIssues',
            query: store.state.permitIssues.permitIssuesFilterParams,
          }),
        },
        children: [
          {
            path: 'view-document/:documentId',
            name: 'permitIssues/permitDocument/view',
            component: () => import('@/views/documents/ViewDocument'),
            beforeEnter: roleAndPermissionGuard,
            meta: {
              allowedRoles: ['admin', 'ltou_admin'],
              requiredPermission: ['is_visible_access_attempts'],
              menuGroup: 'permit-issues',
              getReturnRoute: () => ({
                name: 'permitIssues',
                query: store.state.permitIssues.permitIssuesFilterParams,
              }),
            },
          },
        ],
      },
    ],
  },
  {
    path: '/unauthorized-attempts',
    name: 'unauthorizedAttempts',
    component: () => import('@/views/unauthorized-attempts/UnauthorizedAttempts'),
    beforeEnter: roleAndPermissionGuard,
    meta: {
      allowedRoles: ['admin', 'ltou_admin'],
      requiredPermission: ['is_visible_access_attempts'],
      menuGroup: 'permit-issues',
    },
    children: [
      {
        path: 'edit-permit/:id',
        name: 'unauthorizedAttempts/editPermit',
        component: () => import('@/views/permits/EditPermit'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          noSave: true,
          allowedRoles: ['admin', 'ltou_admin'],
          requiredPermission: ['is_visible_access_attempts'],
          menuGroup: 'permit-issues',
          getReturnRoute: () => ({
            name: 'unauthorizedAttempts',
            query: store.state.unauthorizedAttempts.unauthorizedAttemptsFilterParams,
          }),
        },
        children: [
          {
            path: 'view-document/:documentId',
            name: 'unauthorizedAttempts/permitDocument/view',
            component: () => import('@/views/documents/ViewDocument'),
            beforeEnter: roleAndPermissionGuard,
            meta: {
              allowedRoles: ['admin', 'ltou_admin'],
              requiredPermission: ['is_visible_access_attempts'],
              menuGroup: 'permit-issues',
            },
          },
        ],
      },
    ],
  },
  {
    path: '/issued-vehicle-permits',
    name: 'issuedVehiclePermits',
    component: () => import('@/views/issued-vehicle-permits/IssuedVehiclePermits'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin', 'ltou_admin', 'ltou_employee'], menuGroup: 'statistics' },
  },
  {
    path: '/permit-scanner',
    name: 'permitScanner',
    component: () => import('@/views/permit-scanner/PermitScanner'),
    meta: { isPublic: true },
    children: [
      {
        path: ':permitId/report/:airportId',
        name: 'reportScannedPermitIssue',
        component: () => import('@/views/ReportPermitIssue'),
        meta: { isPublic: true },
      },
    ],
  },
  {
    path: '/locations/:id/check-in',
    name: 'locationScanner',
    component: () => import('@/views/locations/LocationScanner'),
    meta: { isPublic: true },
  },
  {
    path: '/successful-location-check-in',
    name: 'checkInSuccessful',
    component: () => import('@/views/locations/CheckInSuccessful'),
    meta: { isPublic: true },
  },
  {
    path: '/locations/:id/seal-is-damaged',
    name: 'checkInSealIsDamaged',
    component: () => import('@/views/locations/SealIsDamagedConfirmation'),
    meta: { isPublic: true },
  },
  {
    path: '/locations/:id/batch-job-list',
    name: 'batchJobList',
    component: () => import('@/views/locations/BatchJobList'),
    meta: { isPublic: true },
  },
  {
    path: '/must-import-users',
    name: 'mustImportUsers',
    component: () => import('@/views/MustImportUsers'),
    beforeEnter: authGuard,
  },
  {
    path: '/must-change-password',
    name: 'mustChangePassword',
    component: () => import('@/views/MustChangePassword'),
  },
  {
    path: '/must-complete-profile',
    name: 'mustCompleteProfile',
    component: () => import('@/views/MustCompleteProfile'),
    beforeEnter: (to, from, next) => {
      if (store.state.auth.mustCompleteProfile) {
        next();
      } else {
        next('/');
      }
    }
  },
  {
    path: '/this-device',
    name: 'thisDevice',
    component: () => import('@/views/this-device/ThisDevice'),
    beforeEnter: roleGuard,
    meta: { allowedRoles: ['admin', 'ltou_admin'], menuGroup: 'settings' },
  },
  {
    path: '/print-logs',
    name: 'printLogs',
    component: () => import('@/views/print-logs/PrintLogs'),
    beforeEnter: roleAndPermissionGuard,
    meta: {
      requiredPermission: ['show_print_log'],
      allowedRoles: ['admin', 'ltou_admin'],
    },
    children: [
      {
        path: 'print-list',
        name: 'printList',
        component: () => import('@/views/print-logs/PrintList'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          requiredPermission: ['show_print_log'],
          allowedRoles: ['admin', 'ltou_admin'],
        },
      },
      {
        path: 'print-report',
        name: 'printReport',
        component: () => import('@/views/print-logs/PrintReport'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          requiredPermission: ['show_print_log'],
          allowedRoles: ['admin', 'ltou_admin'],
        },
      },
    ],
  },
  {
    path: '/system-log-files',
    name: 'systemLogFiles',
    component: () => import('@/views/SystemLogFiles'),
    beforeEnter: roleGuard,
    meta: {
      allowedRoles: ['admin'],
    },
  },
  {
    path: '/driving-permits',
    name: 'drivingPermits',
    component: () =>
      import(/* webpackChunkName: "drivingPermits" */ '@/views/driving-permits/DrivingPermits'),
    beforeEnter: roleAndPermissionGuard,
    meta: {
      allowedRoles: ['admin', 'subject_admin', 'user'],
      requiredPermission: ['approve_subject_driving_permit', 'driving_training_instructor'],
    },
    children: [
      {
        path: 'create',
        name: 'createDrivingPermit',
        component: () =>
          import(
            /* webpackChunkName: "createDrivingPermit" */ '@/views/driving-permits/CreateDrivingPermit'
          ),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin', 'subject_admin', 'user'],
          requiredPermission: ['approve_subject_driving_permit', 'driving_training_instructor'],
        },
      },
      {
        path: ':id/edit',
        name: 'editDrivingPermit',
        component: () =>
          import(
            /* webpackChunkName: "editDrivingPermit" */ '@/views/driving-permits/EditDrivingPermit'
          ),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin', 'subject_admin', 'user'],
          requiredPermission: ['approve_subject_driving_permit', 'driving_training_instructor'],
        },
        children: [
          {
            path: 'view-document/:documentId',
            name: 'drivingPermitDocument/view',
            component: () => import('@/views/documents/ViewDocument'),
            beforeEnter: roleAndPermissionGuard,
            meta: {
              allowedRoles: ['admin', 'subject_admin', 'user'],
              requiredPermission: ['approve_subject_driving_permit', 'driving_training_instructor'],
            },
          },
        ],
      },
      {
        path: 'driving-permit-report',
        name: 'drivingPermitReport',
        component: () => import('@/views/driving-permits/DrivingPermitReport.vue'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin'],
          requiredPermission: ['driving_training_instructor'],
        },
      },
    ],
  },
  {
    path: '/driving-practice-exams',
    name: 'drivingPracticeExams',
    component: () =>
      import(
        /* webpackChunkName: "drivingPracticeExams" */ '@/views/driving-practice-exams/DrivingPracticeExams'
      ),
    beforeEnter: roleAndPermissionGuard,
    meta: {
      allowedRoles: ['admin'],
      requiredPermission: ['driving_training_instructor'],
    },
    children: [
      {
        path: 'create',
        name: 'createDrivingPracticeExam',
        component: () =>
          import(
            /* webpackChunkName: "createDrivingPracticeExam" */ '@/views/driving-practice-exams/CreateDrivingPracticeExam'
          ),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin'],
          requiredPermission: ['driving_training_instructor'],
        },
      },
      {
        path: ':id/edit',
        name: 'editDrivingPracticeExam',
        component: () =>
          import(
            /* webpackChunkName: "editDrivingPracticeExam" */ '@/views/driving-practice-exams/EditDrivingPracticeExam'
          ),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin'],
          requiredPermission: ['driving_training_instructor'],
        },
      },
      {
        path: ':id/manage',
        name: 'manageDrivingPracticeParticipants',
        component: () =>
          import(
            /* webpackChunkName: "manageDrivingPracticeParticipants" */ '@/views/driving-practice-exams/ManageDrivingPracticeParticipants.vue'
          ),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin'],
          requiredPermission: ['driving_training_instructor'],
        },
        children: [
          {
            path: ':participantId/edit-exam-results',
            name: 'editDrivingPracticeExamResults',
            component: () =>
              import(
                /* webpackChunkName: "editDrivingPracticeExamResults" */ '@/views/driving-practice-exams/ManageDrivingPracticeExam.vue'
              ),
            beforeEnter: roleAndPermissionGuard,
            meta: {
              allowedRoles: ['admin'],
              requiredPermission: ['driving_training_instructor'],
            },
          },
        ],
      },
    ],
  },
  {
    path: '/questionnaires',
    name: 'questionnaires',
    component: () => import('@/views/questionnaires/Questionnaires.vue'),
    beforeEnter: roleAndPermissionGuard,
    meta: {
      allowedRoles: ['admin'],
      requiredPermission: ['driving_training_instructor'],
      menuGroup: 'driving-permit-settings',
    },
    children: [
      {
        path: 'create',
        name: 'createQuestionnaire',
        component: () => import('@/views/questionnaires/CreateQuestionnaire.vue'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin'],
          requiredPermission: ['driving_training_instructor'],
          menuGroup: 'driving-permit-settings',
        },
      },
      {
        path: ':id/edit',
        name: 'editQuestionnaire',
        component: () => import('@/views/questionnaires/EditQuestionnaire.vue'),
        beforeEnter: roleAndPermissionGuard,
        meta: {
          allowedRoles: ['admin'],
          requiredPermission: ['driving_training_instructor'],
          menuGroup: 'driving-permit-settings',
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: import.meta.env.VITE_APP_HTML_HISTORY_MODE ? 'history' : '',
  base: import.meta.env.VITE_APP_PUBLIC_PATH,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.isPublic) {
    next();
    return;
  }
  if (!store.getters['auth/accessToken']) {
    await store.dispatch('auth/tryAutoLogin');
  }
  if (!['login', 'mustImportUsers', 'mustChangePassword', 'mustCompleteProfile'].includes(to.name)) {
    store.commit('auth/SET_LAST_ACCESSED_ROUTE', to);
  }
  if (store.state.auth.shouldImportUsers && to.name !== 'mustImportUsers') {
    next({ name: 'mustImportUsers' });
    return;
  }
  if (
    store.state.auth.mustChangePassword &&
    to.name !== 'mustChangePassword' &&
    to.name !== 'login'
  ) {
    next({ name: 'mustChangePassword' });
    return;
  }

  if (store.state.auth.mustCompleteProfile && to.name !== 'mustCompleteProfile' && to.name !== 'login') {
    next({ name: 'mustCompleteProfile' });
    return;
  }

  if (from.name === 'login') {
    // this logic should refresh the page if there is difference between versions
    const currentVersion =
      document.querySelector("meta[name='app-version']")?.getAttribute('content') || '';
    const metadataUrl = `${import.meta.env.VITE_APP_PUBLIC_PATH}metadata.json`;
    const { data } = await axios.get(`${metadataUrl}?no-cache=${new Date().getTime()}`);

    if (data.version !== currentVersion) {
      eventBus.$emit(OPEN_SNACKBAR, i18n.t('update_available_force_refresh'));
      const url = new URL(window.location.href);
      url.searchParams.delete('no-cache');
      url.searchParams.append('no-cache', new Date().getTime().toString());
      window.location.href = url.href;
    }
  }
  next();
});

router.onError((error, to) => {
  // this is for dynamically imported modules errors handling
  if (
    error.message.includes('dynamically imported module') ||
    error.message.includes('Importing a module script failed') ||
    error.message.includes('Unable to preload CSS for')
  ) {
    if (!to?.fullPath) {
      window.location.reload();
    } else {
      window.location = to.fullPath;
    }
  }
});

export default router;
